import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ActionModal } from 'portal-modules/common/components/modals'
import { connect } from 'react-redux'
import { deleteRenewalEmployer } from 'portal-modules/renewals/redux/modules/renewals'

class CurrentEmployerModal extends Component {
  handleDelete = () => {
    this.props.deleteRenewalEmployer(this.props.id, () => this.props.onClose())
  }
  render() {
    return (
      <ActionModal
        renderConfirmation={() => (
          <p>{__('Are you sure you want to delete this Employer?')}</p>
        )}
        onDelete={this.handleDelete}
        closeOnDeleteCancel
        {...this.props}
      >
        {({ showConfirmation }) => showConfirmation()}
      </ActionModal>
    )
  }
}

CurrentEmployerModal.propTypes = {
  deleteRenewalEmployer: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default connect(
  null,
  { deleteRenewalEmployer },
)(CurrentEmployerModal)
